import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import "./generic-premium.css";

const GenericPremiumPage = ({ title, subtitle, icon: Icon, description, ctaText, ctaLink, contentTitle }) => {
  const resolvedLink = ctaLink || "/";
  const isExternal = /^(https?:|mailto:)/i.test(resolvedLink);
  const buttonLabel = ctaText || "Return Home";

  return (
    <>
      <Helmet>
        <title>{title} | ARAB Global Exchange</title>
        <meta name="description" content={subtitle || description} />
      </Helmet>

      <div className="generic-premium-page top-section-gap">
        <div className="container">
          <div className="gp-header-wrapper">
            <div className="gp-badge-pill">
              <Sparkles size={16} className="gp-text-highlight" />
              <span>Premium Resource</span>
            </div>
            <h1 className="gp-title">{title}</h1>
            {subtitle && <p className="gp-desc">{subtitle}</p>}
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="gp-content-card">
                {Icon && (
                  <div className="gp-placeholder-icon">
                    <Icon size={40} />
                  </div>
                )}
                <h3 className="gp-content-title">{contentTitle || "Coming Soon to ARAB Global"}</h3>
                <p className="gp-content-text">
                  {description || "We are currently building this section to provide you with the most premium and seamless experience. Stay tuned for highly detailed insights and industry-leading features."}
                </p>

                {isExternal ? (
                  <a href={resolvedLink} className="gp-action-btn">
                    {buttonLabel} <ArrowRight size={18} className="ms-2" />
                  </a>
                ) : (
                  <Link to={resolvedLink} className="gp-action-btn">
                    {buttonLabel} <ArrowRight size={18} className="ms-2" />
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenericPremiumPage;
